import { useEffect, useState } from 'react'
import {
    Dialog,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogContent,
    Button,
    Radio,
    RadioGroup,
    Label,
    makeStyles, mergeClasses
} from "@fluentui/react-components"
import {createShoppingReport} from "../../../../api/mission/shopping/shoppingPathJointReport";
import {useStyles} from "../../../../styles/mission/ver1";
import {
    readShoppingReportReasonCount,
    readShoppingReportReasonWithPage
} from "../../../../api/mission/shopping/ShoppingPathJointReportReason";

interface inquryType {
    id: number
    body: string
    createdAt: Date
    modifiedAt: Date
    deletedAt: Date | null
}

const useInquiryStyles = makeStyles({
    form: {
        width: '100%',
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
    },
    errorMessage: {
        color: '#d13438',
        fontSize: '12px',
        marginTop: '4px'
    },
    retryContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
    },
    roundBtn: {
        backgroundColor: 'black',
        padding: '10px',
        borderRadius: '10px',
        fontSize: '15px',
        border: '0px',
        color:'white'
    },
})

export default function InquiryDialog({
                                          isOpen,
                                          onClose,
                                          setIsSubmit,
                                          userId,
                                          shoppingPathJointId,
                                          primaryColor
                                      }: {
    isOpen: boolean
    onClose: () => void
    setIsSubmit?: () => void
    userId: string
    shoppingPathJointId: string
    primaryColor: string
}) {
    const styles = useInquiryStyles()
    const basicStyles = useStyles()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [count, setCount] = useState<number>()
    const [data, setData] = useState<inquryType[]>()
    const [selectedInquiry, setSelectedInquiry] = useState<number>()
    const [error, setError] = useState<string>('')

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        if (!selectedInquiry) {
            setError('항목을 선택해주세요')
            return
        }

        if (shoppingPathJointId != null && userId != null) {
            setIsLoading(true)
            try {
                const res = await createShoppingReport(
                    shoppingPathJointId,
                    userId,
                    selectedInquiry
                )

                if (!res) throw new Error('문의 제출에 실패했습니다.')

                if(setIsSubmit) setIsSubmit()

            } catch (e) {
                alert(e)
                console.error(e)
            } finally {
                setIsLoading(false)
                onClose()
            }
        }
    }

    useEffect(() => {
        getCount()
    }, [])

    useEffect(() => {
        getData()
    }, [count])

    const getCount = async () => {
        try {
            const res = await readShoppingReportReasonCount()
            if (!res) throw new Error('문의 사항 계수 조회 실패')
            setCount(res.result)
        } catch (e) {
            console.error(e)
        }
    }

    const getData = async () => {
        if (!count) return

        try {
            const res = await readShoppingReportReasonWithPage(count, 0)
            setData(res.result)
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>광고넘기기</DialogTitle>

                    <DialogContent>
                        {!data ? (
                            <div className={styles.retryContainer}>
                                <div>문의 사항 불러오기에 실패했습니다.</div>
                                <Button className={styles.roundBtn} onClick={() => getCount()}>다시 시도</Button>
                            </div>
                        ) : (
                            <form onSubmit={onSubmit} className={styles.form}>
                                <RadioGroup
                                    value={selectedInquiry?.toString()}
                                    onChange={(_, data) => {
                                        setSelectedInquiry(Number(data.value))
                                        setError('')
                                    }}

                                >
                                    {data.map((item) => (
                                        <div key={item.id}>
                                            <Radio
                                                value={item.id.toString()}
                                                id={item.id.toString()}
                                            />
                                            <Label htmlFor={item.id.toString()}>{item.body}</Label>
                                        </div>
                                    ))}
                                </RadioGroup>
                                {error && <div className={styles.errorMessage}>{error}</div>}

                                <div style={{display:'flex',gap:"5px", justifyContent:'center'}}>
                                    <Button
                                        type="submit"
                                        disabled={isLoading}
                                        className={mergeClasses(basicStyles.roundedBtn, basicStyles.primaryBtn)}
                                        style={{backgroundColor: primaryColor, border:'none'}}
                                    >
                                        {isLoading ? '제출중...' : '제출하기'}
                                    </Button>
                                    <Button onClick={onClose} className={mergeClasses(basicStyles.roundedBtn, basicStyles.outlinedBtn)}>
                                        닫기
                                    </Button>
                                </div>
                            </form>
                        )}
                    </DialogContent>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    )
}